import {
  Button,
  Image,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import berriesSrc from '@public/images/berries.png';
import { MANAGE_PRACTICE_ROUTE } from '@web-app/components/consts';
import { Text } from '@web-app/components/Typography/Text';
import { useRouter } from 'next/router';
import React, { useEffect, useRef } from 'react';

interface Props {
  enrollments: string[];
}

export const ManagePracticeEnrollmentModal = ({ enrollments }: Props) => {
  const router = useRouter();
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });

  const handleLearnMore = () => {
    onClose();
    router.push(MANAGE_PRACTICE_ROUTE);
  };

  useEffect(() => {
    setTimeout(() => closeButtonRef.current?.blur?.());
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        overflow="hidden"
        borderRadius={10}
        color="text.brand"
        width="447px"
        padding={8}
      >
        <ModalCloseButton ref={closeButtonRef} autoFocus={false} />

        <VStack>
          <Image
            src={berriesSrc.src}
            margin="49px 82px 49px 66px"
            alt="berry"
            width="235px"
            height="172px"
          />

          <Text textType="lg" fontWeight={600} marginBottom="10px">
            Good news! You’re now enrolled with {enrollments[0]}
            {enrollments?.length > 1 ? ' and others' : ''}!
          </Text>

          <Text textType="sm" color="text.muted" marginBottom="16px">
            Check your Practice Dashboard for more details and next steps!
          </Text>

          <Button
            colorScheme="orange"
            onClick={handleLearnMore}
            alignSelf={'flex-start'}
            borderRadius="16px"
          >
            Learn more
          </Button>
        </VStack>
      </ModalContent>
    </Modal>
  );
};
